import React, { Component } from 'react';
import ProgressCircle from  './ProgressCircle';
import atob from 'atob';

const url='http://54.93.73.56:8080/pub/change/password';
const success='success';
const fail='fail';


export default class ChangePassword extends Component{
    token='';
    state={

    };
    constructor(props) {
        super(props);
        this.token=props.match.params.token;
    }
    validatePassword=(password)=> {
        return password.length>2;
    };
    handlePasswordChange=(e) =>{
        const password=e.target.value;
        const isPasswordValid=this.validatePassword(password);
        const isRepeatValid=password===this.state.repeatPassword;
        this.setState(
            {
                password: password,
                isPasswordValid:isPasswordValid,
                isRepeatPasswordValid:isRepeatValid
            });
    };
    handleRepeatPasswordChange=(e) =>{
        const password=e.target.value;
        const isPasswordValid=this.validatePassword(password) && password===this.state.password;
        this.setState(
            {
                repeatPassword: password,
                isRepeatPasswordValid:isPasswordValid
            });
    };
    render () {
        return (
            <div >

                <div className='password-container'>
                    <div className='flex-header'>
                        <p>Смена пароля</p>
                        <form className='email-form'>
                            {this.getPasswordField()}
                            {this.getRepeatPasswordField()}
                            { this.getBottomElement()}
                        </form>
                    </div>
                </div>
                <img className='full-fill' src='../images/back_password.jpg'/>
            </div>);

    };
    getBottomElement=()=>{
        if(this.state.isSending){
            return <ProgressCircle/>;
        }
        if(this.state.sendResult===success){
            return<div className='flex-text-m'> <p>Пароль успешно изменен</p></div>
        }
        if(this.state.sendResult===fail && this.state.isPasswordValid){
            return <div className='flex-text-m'><p className='dark-pink'>Не удалось изменить пароль. Попробуйте получить в игре новую ссылку на изменение пароля</p></div>
        }
        if(this.state.isPasswordValid && this.state.isRepeatPasswordValid){
            return   <button className='send-button' type="button" onClick={this.handleSend}>Изменить пароль</button>;
        }
        if(! this.state.password){
            return <div className='flex-text-m'><p>Введите пароль</p></div>
        }
        if(! this.state.isPasswordValid){
            return <div className='flex-text-m'><p>Некорректный пароль. Минимальная длина: 3 символа</p></div>
        }
            return <div className='flex-text-m'><p>Подтверждение не совпадает с паролем</p></div>
    };
    getPasswordField=()=>{
        if(this.state.isPasswordValid || !this.state.password){
            return <input className='email-input' type="password" name="password" placeholder="Input password" onChange={this.handlePasswordChange} />
        }
        return <input className='email-not-valid' type="password" name="password" placeholder="Input password" onChange={this.handlePasswordChange} />;
    };

    getRepeatPasswordField=()=> {
        if(this.state.isRepeatPasswordValid || !this.state.repeatPassword){
            return <input className='email-input' type="password" name="password" placeholder="Repeat password" onChange={this.handleRepeatPasswordChange} />
        }
        return <input className='email-not-valid' type="password" name="password" placeholder="Repeat password" onChange={this.handleRepeatPasswordChange} />;
    };
    handleSend =() =>{
        const message={
            password:this.state.password,
            token:atob(this.token)
           };
        const xhttp=new XMLHttpRequest();
        xhttp.open("POST", url, true);
        xhttp.setRequestHeader("Content-type", "application/json; charset=utf8");
        xhttp.setRequestHeader( 'Access-Control-Allow-Origin', '*');
        this.setState({isSending: true});
        this.setState({sendResult: undefined});
        xhttp.onreadystatechange = () =>{
            if (xhttp.readyState === xhttp.DONE) {
                console.log(xhttp.status);
                this.setState({isSending: false});
                if (xhttp.status === 200) {
                    console.log(xhttp.response);
                    console.log(xhttp.responseText);
                    const res=xhttp.responseText;
                    if(!res|| JSON.parse(res).value!=='ok'){
                        this.onSendFail();
                        return;
                    }
                    this.setState({sendResult: success});
                }else{
                    this.onSendFail();
                }
            }
        };
        xhttp.send(JSON.stringify(message));

    };

    onSendFail=()=>{
        this.setState({sendResult: fail});
    }

}